
export const environment = {
      // Global Config variables
       gserverName: 'http://uatgiantdatasafeapi/',
     //   gserverName: 'http://testgiantdatasafeapi/',
     gAppURL: 'http://uatgiantdatasafe/',
    //gAppURL: 'http://localhost:4200/',
    gbaseURL: '/GDS/api',
    loginURL: 'http://uatgiantdatasafeapi/GDS/api'
    //loginURL : 'http://localhost:64197/GDS/api'

}


